export const APP_ROUTES = [
  {
    path: '/language',
    name: 'Language',
    description: 'Browse and manage Language records, Modules, and Que Cards.',
    icon: '🌐',
  },
  {
    path: '/landing-page',
    name: 'Landing Page',
    description: 'Browse and manage Landing Page records and survey questions.',
    icon: '🏠',
  },
  {
    path: '/over-quota-users',
    name: 'Over Quota Users',
    description: 'Fetch over-quota users, filter by type/name, bulk swap quotas, revive, and export.',
    icon: '📊',
  },
  {
    path: '/reassign-quota',
    name: 'Reassign Quota',
    description: 'Load all study users, filter and reassign quotas, bulk swap, and export.',
    icon: '🔄',
  },
];

export const NAV_ROUTES = [
  { path: '/', name: 'Home', icon: '🏡' },
  ...APP_ROUTES,
];
